<!--
 * @Description : 标题样式
 * @Author      : jinxin
 * @Date        : 2023-02-16 16:04:54
-->
<template>
    <div class="lc_title_box">
       <div class="lc_title_box_title" v-if="!isShow">
            <span> </span><span>{{ title }}</span>
       </div>
       <div class="lc_title_box_title_n" v-if="isShow">
            <span>{{ title }}</span>
       </div>
    </div>
</template>

<script>
import { defineComponent,reactive } from 'vue'
export default defineComponent({
    props:{
        title:String,
        isShow:Boolean
    },
    setup(props,context){
        let data = reactive({})
        return{
            data,
            props
        }
    }
})
</script>

<style scoped>
.lc_title_box_title{
    display:flex;
    justify-content:left;
    align-items:center;
}
.lc_title_box_title span:nth-child(2){
    color:#303133;
    font-size: 14px;
    font-weight: 700;
}
.lc_title_box_title span:nth-child(1){
    color:#fff;
    height:14px;
    border-left:2px solid #4178D5;
    margin-right:8px;
}
.lc_title_box_title_n{
    color:#303133;
    font-size: 18px;
    font-weight: 500;
}
</style>
